import { Component, Input, OnInit } from '@angular/core';
import { NodeService } from 'src/app/shared/services/node.services';

@Component({
  selector: 'app-view-select-course',
  templateUrl: './view-select-course.component.html',
  styleUrls: ['./view-select-course.component.scss']
})
export class ViewSelectCourseComponent implements OnInit {

  @Input() block: any;
  public valueCheckbox: any[] = [];
  public resetValueCheckbox: boolean = false;
  public arrayData = [
    {
      id: 1,
      titolo: 'Tipo di Corso',
      value: [
        {
          id: 1,
          value: 'Laurea Triennale'
        },
        {
          id: 2,
          value: 'Laurea Magistrale a ciclo unico'
        },
        {
          id: 3,
          value: 'Laurea Magistrale'
        },
        {
          id: 4,
          value: 'Dottorato'
        },
        {
          id: 5,
          value: 'Master I Livello'
        },
        {
          id: 6,
          value: 'Master II Livello'
        }
      ]
    },
    {
      id: 2,
      titolo: 'Area Tematica',
      value: [
        {
          id: 1,
          value: 'Educazione e formazione'
        },
        {
          id: 2,
          value: 'Scienze Politiche'
        },
        {
          id: 3,
          value: 'Giurisprudenza'
        },
        {
          id: 4,
          value: 'Economia e marketing'
        },
        {
          id: 5,
          value: 'Lingue'
        },
        {
          id: 6,
          value: 'Informatica e Innovazione'
        }
      ]
    },
    {
      id: 3,
      titolo: 'Keyword',
      value: [
        {
          id: 1,
          value: 'Keyword 1'
        },
        {
          id: 2,
          value: 'Keyword 2'
        },
        {
          id: 3,
          value: 'Keyword 3'
        },
        {
          id: 4,
          value: 'Keyword 4'
        },
        {
          id: 5,
          value: 'Keyword 5'
        },
        {
          id: 6,
          value: 'Keyword 6'
        },
        {
          id: 4,
          value: 'Keyword 4'
        },
        {
          id: 5,
          value: 'Keyword 5'
        },
        {
          id: 6,
          value: 'Keyword 6'
        },
        {
          id: 4,
          value: 'Keyword 4'
        },
        {
          id: 5,
          value: 'Keyword 5'
        },
        {
          id: 6,
          value: 'Keyword 6'
        },
        {
          id: 7,
          value: 'Keyword 7'
        }
      ]
    },
    {
      id: 4,
      titolo: 'Città',
      value: [
        {
          id: 1,
          value: 'Roma'
        },
        {
          id: 2,
          value: 'Palermo'
        },
        {
          id: 3,
          value: 'Taranto'
        }
      ]
    },
    {
      id: 5,
      titolo: 'Lingua',
      value: [
        {
          id: 1,
          value: 'Italiano'
        },
        {
          id: 2,
          value: 'Italiano e Inglese'
        }
      ]
    }
  ];
  public colString: string = '';


  constructor(private nodeService: NodeService) { }

  ngOnInit(): void {
    // this.nodeService.getTaxonomyForView();
    this.setColumnItem();
  }

  valueEmitCheckbox(emit: any) {
    if (this.valueCheckbox.length < 1) {
      this.valueCheckbox.push(emit);
    } else {
      this.valueCheckbox.forEach((el, idx) => {
        if (el.id_block === emit.id_block) {
          this.valueCheckbox[idx] = emit;
        } else {
          this.valueCheckbox.push(emit);
        }
      })
    }
  }

  searchCourses() {
    this.valueCheckbox = this.valueCheckbox.filter((value: any, index: number) => this.valueCheckbox.indexOf(value) === index);
    this.valueCheckbox = [];
    this.resetValueCheckbox = !this.resetValueCheckbox;
  }

  private setColumnItem() {
    switch (this.arrayData.length) {
      case 1:
        this.colString = 'col-lg-12';
        break;
      case 2:
        this.colString = 'col-lg-6';
        break;
      case 3:
        this.colString = 'col-lg-4';
        break;
      case 4:
        this.colString = 'col-lg-3';
        break;
      case 5:
        this.colString = 'col-lg-2';
        break;
      default:
        break;
    }
  }



}
